import React, { FC } from 'react'

import {
  Button,
  ModalActions,
  ModalContent,
  ModalHeader,
} from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'

interface CardPresentPromptProps {
  close: () => void
  description?: string
  handleContinue: () => void
}

export const CardPresentPrompt: FC<CardPresentPromptProps> = ({
  close,
  description,
  handleContinue,
}) => {
  const t = useT()
  return (
    <>
      <ModalHeader>
        {t('The refund needs a card present to continue.', {
          _context:
            'The prompt header tells the user that a physical card is needed to proceed with the refund.',
        })}
      </ModalHeader>
      <ModalContent>
        <p className="vd-p" data-testid="server-driven-card-present-message">
          {description ||
            t(
              'Due to the type of card that the customer used in the original sale, the same card is required to be presented to process the refund. You can continue or choose another refund type.',
              {
                _context:
                  'The Lightspeed Payments Interac card present prompt message informs the user that the same card used for the original sale is required to process the refund.',
              }
            )}
        </p>
      </ModalContent>
      <ModalActions>
        <div className="vd-btn-group">
          <Button variant="supplementary" onClick={close}>
            {t('Choose a different payment method', {
              _context: 'Button',
            })}
          </Button>
          <Button variant="go" onClick={handleContinue}>
            {t('Continue', {
              _context: 'Button',
            })}
          </Button>
        </div>
      </ModalActions>
    </>
  )
}
